/**
 * Asynchronously loads the component for DashboardBuilderContainer
 */
import Loadable from 'react-loadable';
import Spinner from 'components/FullScreenSpinner';
 
export default Loadable({
  loader: () => import(/* webpackChunkName: "DashboardBuilder" */ './index'),
  loading: Spinner,
});
 